import { createFileRoute } from '@tanstack/react-router'

export interface TemplateLibrarySearch {
  page?: number
  sort?: string
  order?: 'asc' | 'desc'
  /**
   * Comma-separated entity-type preset (e.g. `contract`). Lets a caller deep-link the library
   * pre-filtered — the Agreements surface links here as `?entity_types=contract` so the agency lands
   * on the contract templates it can pick/fork (CE-T11 US-1). The page seeds its initial filter from
   * this; the user can still clear or change it.
   */
  entity_types?: string
}

export const Route = createFileRoute('/forms/library')({
  validateSearch: (search: Record<string, unknown>): TemplateLibrarySearch => ({
    page: typeof search.page === 'number' && search.page > 1 ? search.page : undefined,
    sort: typeof search.sort === 'string' ? search.sort : undefined,
    order: search.order === 'asc' || search.order === 'desc' ? search.order : undefined,
    entity_types: typeof search.entity_types === 'string' ? search.entity_types : undefined,
  }),
})
